<div class="relative p-4 flex flex-col gap-4">
  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Coordonnées bancaires de l'actionnaire</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right whitespace-nowrap">Pays</td>
        <td>
          <select-pays
            [(ngModel)]="actionnaire.pays_ID_Banque"
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-pays>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">IBAN</td>
        <td>
          <iban-input
            [(pays)]="actionnaire.actionnaire_Banque_IBAN"
            [(banque)]="actionnaire.actionnaire_Banque_Code"
            [(guichet)]="actionnaire.actionnaire_Banque_Guichet"
            [(compte)]="actionnaire.actionnaire_Banque_CPT"
            [(cle)]="actionnaire.actionnaire_Banque_CLE"
          ></iban-input>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">BIC</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_Banque_BIC"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Banque</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="100"
              [(ngModel)]="actionnaire.actionnaire_Banque"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Libellé du compte</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Banque_LIB"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Mode de règlement</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              [(ngModel)]="actionnaire.actionnaire_ModeReg"
              [disabled]="actionnaire.actionnaire_Administre == 1"
            >
              <mat-option [value]="0">Chèque</mat-option>
              <mat-option [value]="1">Virement</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
    </table>
  </mat-card>

  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Actionnaire regroupé</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td colspan="2">
          <div class="alert alert-info p-4">
            <div class="flex items-center gap-2">
              <mat-icon>info</mat-icon>
              <div class="flex-1">
                A renseigner si le compte doit être regroupé avec un autre
                actionnaire pour les AGs.
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="text-right items-start">Actionnaire</td>
        <td>
          <select-actionnaire
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-actionnaire>
        </td>
      </tr>
    </table>
  </mat-card>

  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Office notarial</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td colspan="2">
          <div class="alert alert-info p-4">
            <div class="flex items-center gap-2">
              <mat-icon>info</mat-icon>
              <div class="flex-1">
                Cocher et remplir si l'actionnaire est décédé pour transmission
                des règlements.
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="text-right">Office notarial</td>
        <td>
          <mat-checkbox
            [(ngModel)]="actionnaire.actionnaire_Office"
          ></mat-checkbox>
        </td>
      </tr>
      @if (actionnaire.actionnaire_Office) {
      <tr>
        <td class="text-right whitespace-nowrap">Civilité</td>
        <td>
          <select-civilite
            [(ngModel)]="actionnaire.officeCivilite_ID"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-civilite>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Nom / RS</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="100"
              [(ngModel)]="actionnaire.actionnaire_OfficeRS"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Adresse</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_OfficeAdresse1"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Complément</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_OfficeAdresse2"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">CP, Ville</td>
        <td class="flex gap-1">
          <mat-form-field appearance="outline" class="w-20">
            <input
              matInput
              [maxlengthinput]="6"
              [(ngModel)]="actionnaire.actionnaire_OfficeCP"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_OfficeVille"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Pays</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_OfficePays"
            />
          </mat-form-field>
        </td>
      </tr>
      }
    </table>
  </mat-card>
</div>
